import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {UIBaseModule} from '@catui/ui-base.module';
import {DropdownComponent} from '@catuiform/components/dropdown/dropdown.component';
import {FormEntityWizardComponent} from '@catuiform/components/form-entity-wizard/form-entity-wizard.component';
import {FormGroupContainerComponent} from '@catuiform/components/form-group-container/form-group-container.component';
import {FormUserdataComponent} from '@catuiform/components/form-userdata/form-userdata.component';
import {FormSwitchComponent} from '@catuiform/components/form-switch/form-switch.component';
import {InputFileComponent} from '@catuiform/components/input-file/input-file.component';
import {InputListComponent} from '@catuiform/components/input-list/input-list.component';
import {InputTextComponent} from '@catuiform/components/input-text/input-text.component';
import {JsonSchemaFormComponent} from '@catuiform/components/json-schema-form/json-schema-form.component';
import {ModalMultiSelectComponent} from '@catuiform/components/modal-multi-select/modal-multi-select.component';
import {TextOnlyComponent} from '@catuiform/components/text-only/text-only.component';
import {FileDropZoneDirective} from '@catuiform/directives/file-drop-zone.directive';
import {InputSwitchModule, SharedModule} from 'primeng/primeng';
import {FormWizardPaneComponent} from './components/form-wizard-pane/form-wizard-pane.component';
import {FormWizardComponent} from './components/form-wizard/form-wizard.component';

const publicComponents = [
  FormWizardComponent,
  FormWizardPaneComponent,
  FormSwitchComponent,
  JsonSchemaFormComponent,
  InputTextComponent,
  DropdownComponent,
  FormEntityWizardComponent,
  TextOnlyComponent,
  FormGroupContainerComponent,
  FormUserdataComponent,
  InputListComponent,
  ModalMultiSelectComponent,
  InputFileComponent,
];

const imports = [
  CommonModule,
  RouterModule,
  SharedModule,
  InputSwitchModule,
  ReactiveFormsModule,
  UIBaseModule,
];
const declarations = [
  FileDropZoneDirective,
  ...publicComponents,
];

const entryComponents = [...publicComponents];

const exportings = [...publicComponents];
const providers = [];

@NgModule({
  imports,
  declarations,
  providers,
  entryComponents,
  exports: exportings,
})
export class UIFormModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-form/ui-form.module.ts